export const GET_MSG_NOTICES = 'GET_MSG_NOTICES';//获取应用通知

export const GET_MSG_NOTICE = 'GET_MSG_NOTICE'//获取应用通知信息